const MaterialIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_66_171)">
        <path
          d="M22.2842 15.3555C22.5109 15.4908 22.6494 15.7359 22.6494 16C22.6494 16.2641 22.5109 16.5092 22.2842 16.6445L12.3838 22.5439C12.1474 22.6847 11.8526 22.6847 11.6162 22.5439L1.71582 16.6445C1.48912 16.5092 1.35059 16.2641 1.35059 16C1.35059 15.7359 1.48912 15.4908 1.71582 15.3555L4.40918 13.75L5.87402 14.623L3.56641 15.999L12 21.0254L20.4336 15.999L18.125 14.623L19.5898 13.75L22.2842 15.3555Z"
          fill="currentColor"
        />
        <path
          d="M12 2.10051L21.8995 7C21.8995 7 17 13.1436 12 13C7 12.8564 2.10051 7 2.10051 7L12 2.10051Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.05664 9.36426C5.50054 9.66403 5.98222 9.96621 6.49316 10.2539L3.56641 11.999L12 17.0254L20.4336 11.999L17.6133 10.3184C18.1158 10.0271 18.5889 9.71921 19.0244 9.41309L22.2842 11.3555C22.5109 11.4908 22.6494 11.7359 22.6494 12C22.6494 12.2641 22.5109 12.5092 22.2842 12.6445L12.3838 18.5439C12.1474 18.6847 11.8526 18.6847 11.6162 18.5439L1.71582 12.6445C1.48912 12.5092 1.35059 12.2641 1.35059 12C1.35059 11.7359 1.48912 11.4908 1.71582 11.3555L5.05664 9.36426Z"
          fill="currentColor"
        />
        <path
          d="M7.5 11.5C8.79032 11.375 10.4516 10.6 12 8.5C13.5 10 14.5 11 16.5 11.5"
          stroke="currentColor"
          strokeWidth="2"
        />
      </g>
      <defs>
        <clipPath id="clip0_66_171">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MaterialIcon;
